import { render } from "./CarSubcheckList.vue?vue&type=template&id=b973db52"
import script from "./CarSubcheckList.vue?vue&type=script&lang=js"
export * from "./CarSubcheckList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__